import React from "react";
import { useNavigate } from "react-router-dom";

const WristHandPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .wrist-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #f0f9ff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .wrist-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .wrist-hero {
          display: grid;
          grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.1fr);
          gap: 24px;
          padding: 28px;
          border-radius: 26px;
          background: linear-gradient(135deg, rgba(14, 165, 233, 0.12), rgba(59, 130, 246, 0.05));
          margin-bottom: 32px;
        }

        @media (max-width: 820px) {
          .wrist-hero {
            grid-template-columns: 1fr;
          }
        }

        .wrist-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(14, 165, 233, 0.22);
          color: #0369a1;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }
        .wrist-tag-dot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #0369a1;
        }

        .wrist-title {
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          margin-bottom: 8px;
        }

        .wrist-subtitle {
          font-size: 15px;
          max-width: 540px;
          color: #374151;
        }

        .wrist-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }
        .wrist-chip {
          padding: 6px 12px;
          background: #0f172a;
          color: white;
          border-radius: 999px;
          font-size: 11px;
        }

        .wrist-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .wrist-btnPrimary,
        .wrist-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: 0.15s ease;
        }

        .wrist-btnPrimary {
          background: #0284c7;
          color: #f8fafc;
          box-shadow: 0 10px 24px rgba(2, 132, 199, 0.35);
        }
        .wrist-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 30px rgba(2, 132, 199, 0.45);
        }

        .wrist-btnSecondary {
          background: rgba(15, 23, 42, 0.08);
          color: #111827;
          border: 1px solid rgba(148,163,184,0.6);
        }

        .wrist-hero-image {
          width: 100%;
          border-radius: 26px;
          object-fit: cover;
          box-shadow: 0 14px 34px rgba(0,0,0,0.18);
        }

        /* STRIPES */
        .wrist-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148,163,184,0.4);
        }

        .wrist-sectionTitle {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .wrist-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .wrist-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .wrist-flexCol {
          flex: 1 1 260px;
        }

        .wrist-image {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
        }

        /* Cards */
        .wrist-triplet {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px,1fr));
          gap: 16px;
        }

        .wrist-card {
          background: rgba(15,23,42,0.02);
          border: 1px solid rgba(148,163,184,0.5);
          padding: 12px 14px;
          border-radius: 18px;
        }

        .wrist-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .wrist-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* Timeline */
        .wrist-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit,minmax(150px,1fr));
          gap: 10px;
        }

        .wrist-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15,23,42,0.04);
        }

        .wrist-stepLabel {
          font-size: 12px;
          font-weight: 700;
        }

        .wrist-stepText {
          font-size: 12px;
          color: #374151;
        }

        /* Banner */
        .wrist-banner {
          margin-top: 18px;
          border-radius: 26px;
          overflow: hidden;
          position: relative;
        }
        .wrist-banner img {
          width: 100%;
          height: 250px;
          object-fit: cover;
        }

        .wrist-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg,rgba(15,23,42,0.8),transparent 60%);
          padding: 18px 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 8px;
        }

        .wrist-bannerText {
          color: #e0e7ff;
          max-width: 400px;
          font-size: 15px;
        }

        .wrist-bannerButtons button {
          padding: 7px 12px;
          font-size: 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .wrist-bannerButtons .primary {
          background: #22c55e;
          color: #064e3b;
        }
        .wrist-bannerButtons .secondary {
          background: rgba(255,255,255,0.15);
          color: white;
          border: 1px solid rgba(255,255,255,0.5);
        }

      `}</style>

      <div className="wrist-page">
        <div className="wrist-inner">

          {/* HERO */}
          <section className="wrist-hero">
            <div>
              <div className="wrist-tag">
                <span className="wrist-tag-dot" />
                Wrist & Hand Relief
              </div>

              <h1 className="wrist-title">
                Reduce wrist & hand pain so gripping, typing, and daily tasks feel possible again.
              </h1>

              <p className="wrist-subtitle">
                The wrist joint, carpal area, tendons, and thumb muscles all work together for gripping, lifting, typing, and fine motor tasks. When irritated, even simple motions can feel sharp or burning.
              </p>

              <div className="wrist-chips">
                <div className="wrist-chip">Carpal tightness</div>
                <div className="wrist-chip">Typing soreness</div>
                <div className="wrist-chip">Thumb weakness</div>
                <div className="wrist-chip">Grip pain</div>
              </div>

              <div className="wrist-ctaRow">
                <button className="wrist-btnPrimary" onClick={() => navigate("/appointments")}>
                  Book wrist & hand visit →
                </button>
                <button className="wrist-btnSecondary" onClick={() => navigate("/staff")}>
                  Meet our therapists
                </button>
              </div>
            </div>

            <img
              src="/content/wrist-hand/wrist_hand_hero.jpg"
              alt="Therapist supporting a patient's wrist and hand"
              className="wrist-hero-image"
            />
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="wrist-stripe">
            <h2 className="wrist-sectionTitle">What can go wrong in the wrist & hand?</h2>
            <p className="wrist-sectionSubtitle">
              The wrist relies on many small muscles and tendons. Even mild irritation can cause major functional problems.
            </p>

            <div className="wrist-flexRow">
              <div className="wrist-flexCol">
                <ul className="wrist-list">
                  <li><span className="wrist-bullet"></span> Pain at the wrist joint with pushing, typing, or extending.</li>
                  <li><span className="wrist-bullet"></span> Tightness in the carpal region from gripping or repetitive tasks.</li>
                  <li><span className="wrist-bullet"></span> Irritation of finger flexors from phone use or tools.</li>
                  <li><span className="wrist-bullet"></span> Finger extensor soreness from typing or mouse strain.</li>
                  <li><span className="wrist-bullet"></span> Thumb/thenar muscle fatigue or sharp pain during pinching.</li>
                </ul>

                <div className="wrist-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="wrist-btnPrimary" onClick={() => navigate("/appointments")}>
                    Check your wrist symptoms →
                  </button>
                  <button className="wrist-btnSecondary" onClick={() => navigate("/contact")}>
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="wrist-flexCol" style={{ textAlign: "center" }}>
                <img
                  src="/content/wrist-hand/wrist_flexors.jpg"
                  alt="Therapist releasing wrist flexor muscles"
                  className="wrist-image"
                />
              </div>
            </div>

            <div className="wrist-triplet">
              <div className="wrist-card">
                <div className="wrist-cardTitle">Finger Flexors</div>
                <div className="wrist-cardText">Inside forearm to palm—responsible for gripping, typing, and holding objects.</div>
              </div>

              <div className="wrist-card">
                <div className="wrist-cardTitle">Finger Extensors</div>
                <div className="wrist-cardText">Top of hand/forearm—help stabilize the wrist and extend the fingers.</div>
              </div>

              <div className="wrist-card">
                <div className="wrist-cardTitle">Thenar Thumb Group</div>
                <div className="wrist-cardText">Small but powerful muscles that help with thumb control and pinching.</div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="wrist-stripe">
            <div className="wrist-flexRow">
              <div className="wrist-flexCol">
                <img
                  src="/content/wrist-hand/wrist_extensors.jpg"
                  alt="Therapist working on finger/wrist extensors"
                  className="wrist-image"
                />
              </div>

              <div className="wrist-flexCol">
                <h2 className="wrist-sectionTitle">How physical therapy helps the wrist & hand</h2>
                <p className="wrist-sectionSubtitle">
                  We calm irritated tissue, restore smooth tendon motion, and help you grip, type, and use your hand comfortably.
                </p>

                <ul className="wrist-list">
                  <li><span className="wrist-bullet"></span> Soft-tissue work for tight wrist flexors/extensors.</li>
                  <li><span className="wrist-bullet"></span> Gentle joint mobilization to restore pain-free motion.</li>
                  <li><span className="wrist-bullet"></span> Grip retraining to reduce strain during daily tasks.</li>
                  <li><span className="wrist-bullet"></span> Thumb strengthening for thenar muscle stability.</li>
                  <li><span className="wrist-bullet"></span> Tendon glides to reduce carpal tightness.</li>
                </ul>

                <div className="wrist-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="wrist-btnPrimary" onClick={() => navigate("/appointments")}>
                    Start wrist/hand therapy →
                  </button>
                  <button className="wrist-btnSecondary" onClick={() => navigate("/insurance")}>
                    Check insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="wrist-stripe">
            <h2 className="wrist-sectionTitle">What a wrist & hand visit looks like</h2>

            <div className="wrist-flexRow">
              <div className="wrist-flexCol">
                <img
                  src="/content/wrist-hand/wrist_exercises.jpg"
                  alt="Patient performing wrist exercises"
                  className="wrist-image"
                />
              </div>

              <div className="wrist-flexCol">
                <div className="wrist-timeline">
                  <div className="wrist-step">
                    <div className="wrist-stepLabel">1. Your story</div>
                    <div className="wrist-stepText">What motions hurt? What tasks bring it on? What do you need your wrist/hand for?</div>
                  </div>

                  <div className="wrist-step">
                    <div className="wrist-stepLabel">2. Motion & strength check</div>
                    <div className="wrist-stepText">Tendon motion, grip strength, wrist mobility, thumb strength.</div>
                  </div>

                  <div className="wrist-step">
                    <div className="wrist-stepLabel">3. Hands-on relief</div>
                    <div className="wrist-stepText">Manual techniques to calm irritation and improve glide.</div>
                  </div>

                  <div className="wrist-step">
                    <div className="wrist-stepLabel">4. Short home plan</div>
                    <div className="wrist-stepText">A small, repeatable set of wrist/hand moves.</div>
                  </div>
                </div>

                <div className="wrist-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="wrist-btnPrimary" onClick={() => navigate("/appointments")}>
                    Book evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="wrist-stripe">
            <div className="wrist-banner">
              <img
                src="/content/wrist-hand/wrist_banner.jpg"
                alt="Calm physical therapy clinic for hand and wrist rehab"
              />
              <div className="wrist-bannerOverlay">
                <div className="wrist-bannerText">
                  Wrist & hand therapy happens in a calm, supportive environment designed to improve comfort and confidence.
                </div>
                <div className="wrist-bannerButtons">
                  <button className="primary" onClick={() => navigate("/appointments")}>
                    Schedule visit →
                  </button>
                  <button className="secondary" onClick={() => navigate("/office")}>
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default WristHandPT;
